import React from "react";
import {
  MapPin,
  Mail,
  Phone,
  Facebook,
  Linkedin,
  Instagram,
  Twitter,
} from "lucide-react";

export default function Topbar() {
  return (
    <div className="bg-gradient-to-r hidden md:block fixed top-0 left-0 w-full z-50 from-green-900 to-orange-300 text-white py-1 px-6 md:px-12 shadow-md">
      <div className="flex flex-row justify-between items-center w-full space-y-2 md:space-y-0">
        {/* Left Section */}
        <div className="flex flex-col md:flex-row items-center md:space-x-6 space-y-2 md:space-y-0">
      
          <a
            href="mailto:mail@precisiongrow.co.in"
            className="flex items-center space-x-2 hover:text-gray-200 transition"
          >
            <Mail className="text-orange-400 w-4 h-4" />
            <span>mail@precisiongrow.co.in</span>
          </a>

          <a
            href="tel:+918097283444"
            className="flex items-center space-x-2 hover:text-gray-200 transition"
          >
            <Phone className="text-orange-400 w-4 h-4" />
            <span>+91 80972 83444</span>
          </a>
        </div>

        {/* Right Section - Social Icons */}
        <div className="flex space-x-4">
          {[Facebook, Linkedin, Instagram, Twitter].map((Icon, idx) => (
            <a
              key={idx}
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full bg-white/20 hover:bg-white/40 transition flex items-center justify-center"
            >
              <Icon className="text-green-950 w-4 h-4 md:w-5 md:h-5" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
